/**
 * Client fire-and-forget helper for PATCH /api/play/updates/read.
 * Never throws — mark-read must not interrupt Play navigation.
 */

export async function markPlayUpdatesRead(
  eventIds: string[]
): Promise<{ ok: boolean; updated?: number }> {
  const ids = eventIds
    .filter((id) => typeof id === 'string' && id.trim().length > 0)
    .map((id) => id.trim())
  if (ids.length === 0) return { ok: true, updated: 0 }

  try {
    const response = await fetch('/api/play/updates/read', {
      method: 'PATCH',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ eventIds: ids }),
      cache: 'no-store',
    })
    if (!response.ok) return { ok: false }
    const body = (await response.json().catch(() => null)) as {
      success?: boolean
      updated?: number
    } | null
    if (!body?.success) return { ok: false }
    return { ok: true, updated: body.updated }
  } catch {
    return { ok: false }
  }
}
